import { useWindowSize } from 'usehooks-ts';
import { HorizontalView } from './HorizontalView';
import { VerticalView } from './VerticalView';
import { ImageLoading } from './components/image_loading';

export const CameraView = () => {
  const { width = 0, height = 0 } = useWindowSize();
  if (width > height) {
    return (
      <>
        <ImageLoading />
        <HorizontalView />
      </>
    );
  }

  return (
    <>
      <ImageLoading />
      <VerticalView />
    </>
  );
};
